// extracted by mini-css-extract-plugin
export default {"root":"iRsURe","inner":"dRrArn","themeWhite":"ZRgqI1","themeRed":"AbCBqg","colorBlack":"H3FbJT","colorRed":"cHEtnB","colorOrange":"op2tmM"};